/**
 * Session-scoped memory of the clarifying answers the user submitted on a given
 * assistant message (the <ClarifyCard/> choices).
 *
 * Same problem and same shape as reportHandoffStore: the card keeps its answer
 * in component state, which is lost when the user switches chats and comes back
 * (the component re-mounts). Persisting it here, keyed by the message's server
 * id, lets the re-mounted card show the collapsed summary instead of
 * resurrecting an already-answered question set.
 *
 * Module-level (survives re-mounts and chat navigation within the session);
 * intentionally NOT localStorage - a full page reload re-fetches the
 * conversation, where the submitted answer is already a real user turn.
 */
const answers = new Map();

/** The submitted rows ([{ id, header, question, answer }]) or null. */
export function getClarifyAnswer(messageId) {
  return messageId != null ? answers.get(messageId) || null : null;
}

export function setClarifyAnswer(messageId, rows) {
  if (messageId != null) answers.set(messageId, rows);
}

/** Drop everything - used when the user deletes all chat history. */
export function clearAllClarifyAnswers() {
  answers.clear();
}
